export class SearchButton {
  #searchButtons: NodeListOf<HTMLButtonElement> | null = null;
  #searchScreen: HTMLDialogElement | null = null;
  #closeButton: HTMLButtonElement | null = null;
  constructor() {
    this.#searchButtons =
      document.querySelectorAll<HTMLButtonElement>('.search-button');
    this.#searchScreen =
      document.querySelector<HTMLDialogElement>('#search-screen');
    this.#closeButton =
      this.#searchScreen?.querySelector<HTMLButtonElement>('.close-button') ??
      null;
  }
  init() {
    this.#searchButtons?.forEach((searchButton) => {
      searchButton.addEventListener('click', this.#showSearchScreen);
    });
    this.#closeButton?.addEventListener('click', this.#closeSearchScreen);
    this.#searchScreen?.addEventListener('click', this.#handleContainerClick);
    this.#searchScreen?.addEventListener('cancel', this.#closeSearchScreen);
  }
  dispose() {
    this.#searchButtons?.forEach((searchButton) => {
      searchButton.removeEventListener('click', this.#showSearchScreen);
    });
    this.#closeButton?.removeEventListener('click', this.#closeSearchScreen);
    this.#searchScreen?.removeEventListener(
      'click',
      this.#handleContainerClick
    );
    this.#searchScreen?.removeEventListener('cancel', this.#closeSearchScreen);
  }
  #showSearchScreen = () => {
    this.#searchButtons?.forEach((searchButton) => {
      searchButton.setAttribute('aria-expanded', 'true');
    });
    this.#searchScreen?.showModal();
    document.body.style.overflow = 'hidden';
  };
  #closeSearchScreen = () => {
    this.#searchButtons?.forEach((searchButton) => {
      searchButton.setAttribute('aria-expanded', 'false');
    });
    this.#searchScreen?.close();
    document.body.style.overflow = '';
  };
  #handleContainerClick = (event: MouseEvent) => {
    console.log('click', event);
    if (event.target === event.currentTarget) {
      this.#closeSearchScreen();
    }
  };
}
